import { Container } from "@mui/material";
import Grid from "@mui/material/Grid2";
import OurJourney from "../../page/animationcounter/OurJourney";
import Contactform from "../../page/contactus/Contactforms";
import test, {
  // SOLUTION_TABS,
  PROVIDE_SOLUTION_TABS,
  TRUSTED_BY,
  TRUSTED_BY_REVERSE,
  homedata,
} from "./constant";
import "./home.scss";
// import { useSpring, animated } from "react-spring";
import { useDispatch } from "react-redux";
import useAutoTabSwitch from "../../customhooks/useAutoTabSwitch";
import TestimonialSlider from "../../page/services/mainservices/implementationanddeployment/segments/service_cloud/service_cloud_pages/TestimonialSlider";

// import ClientSlider from "./ClientSlider";
import SolutionForBusiness from "./SolutionForBusiness";
import { setNav_Item } from "../../redux/NavBarSlice";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// import SvgLine1 from "../../Components/svglines/SvgLine1";
// import SvgLine2 from "../../Components/svglines/SvgLine2";
// import HomeCardslider from "./HomeCardslider";
import Ambitionslider from "./Ambitionslider";
// import Salesforcedms from "../../page/services/mainservices/implementationanddeployment/segments/Dmsimplementation/Dmsimlimentationpages/Salesforcedms";
// import { dmsobj } from "../../page/services/mainservices/implementationanddeployment/segments/Dmsimplementation/constant";
import Technicalexp from "./Technicalexp";
import Deepplatform from "./Deepplatform";
import Industrycentric from "./Industrycentric";
import TakeOurword from "./TakeOurword";
import useActiveNavItem from "../../customhooks/UseActiveNavItem";
import SEO from "../../seo/SEO";
import homeschema from "../../seo/schema/homeschema";
import homeFaqschema from "../../seo/schema/homeFaqschema";
import AtomButton from "../../atoms/button/button";
import { CERTICICATES_CLOUDE } from "./certificates/constant";
import CertiCard from "./certificates/CertiCard";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firbase/firebase";
import FAQ from "./FAQ";

export const handleScheduleCall = () => {
  window.open(
    "https://calendly.com/chandan-k-utilitarianlabs/30min", // <--  Calendly
    "_blank",
    "noopener,noreferrer",
  );
};

const HomeTemplate = () => {
  useEffect(() => {
    logEvent(analytics, "home_page_view", {
      content_id: "home_page",
      content_type: "home",
    });
  }, []);

  const dispatch = useDispatch();
  useActiveNavItem();

  const tabCount_provide = PROVIDE_SOLUTION_TABS.length;
  const [currentTabProvide, setCurrentTabProvide] = useAutoTabSwitch(
    tabCount_provide,
    4000,
  );

  const handleTabChangeProvider = (event, newValue) => {
    setCurrentTabProvide(newValue);
  };

  const handlenavigate = (clickedpath) => {
    // const path = window.location.pathname;
    const path = clickedpath;
    console.log("from home path", path);
  };

  useEffect(() => {
    const path = window.location.pathname;
    if (
      [
        "impact",
        "about",
        "insights",
        "insight-blog",
        "contactus",
        "termsandconditions",
        "privacypolicy",
        "Contactform",
      ].some((route) => window.location.pathname.includes(route))
    ) {
      dispatch(setNav_Item(null));
    } else if (path.includes("careers")) {
      dispatch(setNav_Item("careers"));
    } else if (path.includes("solutions")) {
      dispatch(setNav_Item("solutions"));
    } else if (path.includes("services")) {
      dispatch(setNav_Item("services"));
    } else if (path.includes("industry")) {
      dispatch(setNav_Item("industries"));
    } else if (path.includes("products")) {
      dispatch(setNav_Item("products"));
    }
  }, [dispatch]);

  const navigate = useNavigate();
  const combinedSchema = [homeschema, homeFaqschema];
 

  return (
    <>
      <SEO
        title="Salesforce Consulting & Implementation Partner | Utilitarian Labs"
        description="We are strategic Salesforce consulting partners delivering scalable solutions, seamless implementations, and measurable business outcomes."
        keywords="Salesforce consulting, Salesforce implementation partner, Salesforce CRM services"
        canonical="https://www.utilitarianlabs.com/"
        ogImage="https://www.utilitarianlabs.com/images/newglogo.png"
        schema={combinedSchema}
      />

      <main className="newhome">
        {/* <section className="magzine">
          <div className="mag_buttons">
            <button
              className="strokebtn1"
              onClick={() =>
                navigate(
                  "https://businessconnectindia.in/utilitarian-labs-salesforce-transformation/",
                )
              }
            >
              VIEW WEBSITE
            </button>
            <button
              className="strokebtn"
              onClick={() =>
                navigate(
                  "https://businessconnectmagazine.in/2026/Excellence-in-Salesforce-Consulting-2026/",
                )
              }
            >
              VIEW MAGAZINE
            </button>
          </div>

          <img src="/images/Business_Connect_Banner_2.webp" className="deskbanner" alt="" />
          <img src="/images/bucmob.webp" className="mobbanner" alt="" />
        </section> */}
        <section className="home-container">
          <section className="vdowrap">
            <video
              autoPlay
              loop
              muted
              playsInline
              preload="none"
              //poster="/images/homeposter.webp"
              className="background-video"
            >
              <source src="/assest/teamvdo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </section>
          <Grid className="homecont">
            <h1>
              Your Vision, Amplified. <br /> Our Partnership, Proven.
            </h1>
            <p>
              We go beyond implementation. We are strategic partners in your
              growth, <br /> leveraging the full power of the Salesforce
              platform to deliver tangible business <br /> outcomes.
            </p>
            <Grid className="btnbox">
              <button className="btn1" onClick={() => navigate("/Contactform")}>
                CONTACT US
              </button>
              <button className="btn2" onClick={handleScheduleCall}>
                SCHEDULE A CALL
              </button>
            </Grid>
          </Grid>
        </section>

        <OurJourney />
        <Ambitionslider />
        <Deepplatform />
        <Technicalexp data={homedata} />
        <Industrycentric />

        <section className="trusted-companies">
          <h2>Our Assets - Our Customers </h2>

          <div className="brand-slider">
            {[...Array(2)].map((_, i) => (
              <section className="slide-track" key={i}>
                {TRUSTED_BY.map((logo, index) => (
                  <section className="slideu" key={`${i}-${index}`}>
                    <img loading="lazy" src={logo} alt="logo" />
                  </section>
                ))}
              </section>
            ))}
          </div>

          <div className="brand-slider">
            {[...Array(2)].map((_, i) => (
              <section className="slide-track reverse" key={`reverse-${i}`}>
                {TRUSTED_BY_REVERSE.map((logo, index) => (
                  <section className="slideu" key={`reverse-${i}-${index}`}>
                    <img loading="lazy" src={logo} alt="logo" />
                  </section>
                ))}
              </section>
            ))}
          </div>
        </section>
        <TakeOurword />

        <div className="all_certicates">
          <Container>
            <Grid
              container
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              // border={"1px solid"}
            >
              <div className="certi_head1">
                Certified to Deliver Salesforce Excellence
              </div>
              <div className="certi_head2">
                Sales Cloud, Services Cloud, Marketing Cloud, IAM, Architect and
                Many More
              </div>
              <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                flexWrap={"wrap"}
                // border={"2px solid red"}
                gap={"24px"}
                marginBottom={"24px"}
              >
                {CERTICICATES_CLOUDE.slice(0, 8).map((item) => (
                  <CertiCard data={item} />
                ))}
              </Grid>

              <AtomButton
                className={`custom-footer-btn`}
                name={"viewmore"}
                color={"primary"}
                size={"large"}
                variant={"contained"}
                onClick={() => {
                  logEvent(analytics, "certificate_VIEW_MORE", {
                    content_id: "certificate_view_more",
                  });
                  navigate("/certifications");
                }}
              >
                View More
              </AtomButton>
            </Grid>
          </Container>
        </div>

        <FAQ />

        <TestimonialSlider />
      </main>
    </>
  );
};

export default HomeTemplate;
